export enum SharedConstants {
  TEAMS = "teams",
  PASSWORD = "password",
  CONFIRM_PASSWORD = "confirmPassword",
  NEW_USERNAME = "newUsername",
  UPDATE = "update",
  BASIC = "Basic",
  PROFESSIONAL = "Professional",
  VIBER = "Viber",
  WHATS_APP = "Whats app",
  MESSAGE = "Message",
  FULL_NAME = "fullName",
  EMAIL = "email",
  NAME = "name",
  SURNAME = "surname",
  DOLLAR_EXCHANGE_RATE = 380,
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
  ALL = "all",
  INCOMING = "incoming",
  BALANCE_TRANSFER = "balanceTransfer",
  CURRENCY = "֏",
  AMD_CURRENCY = "AMD",
  TRANSFER = "TRANSFER",
  REQUIRED = "required",
  MAX_LENGTH = "maxlength",
  PATTERN = "pattern",
  MIN_LENGTH = "minlength",
  MY_TEAMS = "My Teams",
  INDIVIDUAL_CARDS = "Individual Cards",
  FREE = "Free",
  PAY_TO_YANDEX = "Pay to Yandex",
  USD = "USD",
  MY_TEAM = "My Team",
  TEAM = "Team",
  ACTIVE_TEAM_INDEX = 'activeTeamIndex',
  EMPTY = "empty",
  ENTITY_TYPE_INDIVIDUAL = "individual",
  ENTITY_TYPE_TEAM = "team",
  ENTITY_TYPE_USER = "user"
}
